import React, { forwardRef } from 'react';
import { clsx } from 'clsx';
import { APP_FOCUS_RING } from './appThemeClasses';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  className,
  id,
  readOnly,
  ...props
}, ref) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-app-text-muted dark:text-gray-300 mb-1"
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        ref={ref}
        readOnly={readOnly}
        className={clsx(
          'w-full px-4 py-2 border rounded-lg transition-colors duration-200',
          'bg-app-surface dark:bg-gray-800 border-app-border dark:border-gray-700 text-app-text dark:text-white',
          error
            ? 'border-error-500 focus:ring-error-500'
            : 'border-app-border dark:border-gray-600',
          readOnly
            ? 'bg-gray-100 dark:bg-gray-700/60 text-gray-600 dark:text-gray-400 cursor-default focus:outline-none focus:ring-0 focus:border-app-border dark:focus:border-gray-600'
            : APP_FOCUS_RING,
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-error-600 dark:text-error-400">{error}</p>
      )}
      {helperText && !error && (
        <p className="mt-1 text-sm text-app-text-muted dark:text-gray-400">{helperText}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

